var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions-col"},[(!_vm.params.hide)?_c('DotsIcon',{attrs:{"popup-items":_vm.params.popupActions},on:{"popup-item":function($event){return _vm.params.onPopupAction($event.name)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }